import { RevealOnScroll } from './Motion';

const steps = [
    {
        num: '01',
        title: 'اختر استطلاعًا',
        body: 'تصفّح دليلًا يقتصر على الاستطلاعات التي تدفع فعلًا. كل مدخل مُراجَع يدويًا: المكافأة، الوقت، والمنصّة المُصدِرة.',
    },
    {
        num: '02',
        title: 'أجب بصدق',
        body: 'الشركات تدفع مقابل رأيك الحقيقي. الصدق في الاستطلاعات هو ما يُبقيك مؤهّلًا لاستطلاعات ذات مكافآت أعلى.',
    },
    {
        num: '03',
        title: 'استلم مكافأتك',
        body: 'الدفع يتم عبر المنصّات نفسها: PayPal، تحويل بنكي، أو بطاقات هدايا — بشفافية كاملة بينك وبين المنصّة الأصلية.',
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            className="relative border-t border-ink/20 py-24 md:py-32"
            data-testid="how-it-works-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <RevealOnScroll>
                    <div className="flex items-baseline justify-between flex-wrap gap-6 mb-16">
                        <div>
                            <div className="text-[11px] uppercase tracking-[0.3em] mb-4 text-ink-600">
                                — الطريقة
                            </div>
                            <h2 className="font-display font-black text-4xl md:text-6xl leading-[1.05] tracking-tight">
                                كيف تعمل المنصة
                            </h2>
                        </div>
                        <div className="max-w-sm text-ink-600 text-sm leading-relaxed">
                            ثلاث خطوات بسيطة تفصلك عن أولى مكافآتك. بلا التفاف، بلا تعقيد.
                        </div>
                    </div>
                </RevealOnScroll>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/20 border border-ink/20">
                    {steps.map((s, i) => (
                        <RevealOnScroll key={i} delay={i * 0.1}>
                            <div className="bg-sand-100 p-8 md:p-10 h-full">
                                <div className="font-display font-black text-6xl md:text-7xl text-emerald-signal mb-6">
                                    {s.num}
                                </div>
                                <h3 className="font-display font-black text-2xl md:text-3xl mb-4 leading-tight">
                                    {s.title}
                                </h3>
                                <p className="text-ink-600 leading-relaxed text-sm">
                                    {s.body}
                                </p>
                            </div>
                        </RevealOnScroll>
                    ))}
                </div>
            </div>
        </section>
    );
}
